/* eslint-disable no-underscore-dangle */
import { Route } from './route'

export function route<TNested extends { [key: string]: Route }>(
  path: string | TNested = '',
  nestedRoutes?: TNested,
  wrapperRoute?: true
): Route & TNested {
  let routeEntry: Route

  if (typeof path === 'string') {
    routeEntry = new Route(path, nestedRoutes, wrapperRoute)
  } else {
    routeEntry = new Route('', path, wrapperRoute)
  }

  const subRoutes = routeEntry._subRoutes

  if (subRoutes) {
    const keys = Object.keys(subRoutes)
    const numSubRoutes = keys.length

    for (let i = 0; i < numSubRoutes; i++) {
      const key = keys[i]
      const nestedEntry = subRoutes[key]

      nestedEntry._parent = routeEntry
      ;(routeEntry as unknown as { [key: string]: Route })[key] = nestedEntry
    }
  }

  return routeEntry as Route & TNested
}
